<!--
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-01 16:29:21
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-15 16:39:50
-->
<template>
  <SModal :visible="visible" :allowClose="true" class="s-modal">
    <div class="modal-tip">
      <i class="icon icon-close" @click="handleClose"/>
      <div class="title">{{ $t('change_role') }}</div>
      <div class="title-tip">{{ $t('please_select_role') }}</div>
      <ServerRole class="server-role" @select="handleClose"/>
    </div>
  </SModal>
</template>
<script>
import ServerRole from '../infoBinding/ServerRoleForm'

export default {
  name: 'ChangeRoleModal',
  components: { ServerRole },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      savedRole: ''
    }
  },
  created () {
    this.savedRole = this.$store.getters.roleName
  },
  methods: {
    handleClose () {
      if (this.$store.getters.roleName !== this.savedRole) {
        this.$tip({
          content: this.$t('change_role_success')
        })
      }
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="less" scoped>
.server-role {
    margin-top: 36px;
    /deep/ .tip-red {
        margin: 20px 0 10px;
    }
    /deep/ .s-button {
        position: inherit;
        margin-top: 10px;
    }
}
@media screen and (max-width: 750px) {
    .server-role {
        margin-top: 5.8667rem /* 44/7.5 */;
        /deep/ .tip-red {
            margin: 2.9333rem /* 22/7.5 */ 0 2.1333rem;
        }
        /deep/ .s-button {
            margin-top: 0;
        }
        /deep/ .server {
            .select {
                // margin-bottom: 3.2rem /* 24/7.5 */;
                margin: 0 auto 3.2rem;
            }
        }
    }
}
</style>
